const HOURS = Array.from({ length: 24 }, (_, i) =>
  i.toString().padStart(2, "0"),
);
const MINUTES = Array.from({ length: 60 }, (_, i) =>
  i.toString().padStart(2, "0"),
);

function parseTime(value: string): { hour: string; minute: string } {
  const match = value?.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return { hour: "09", minute: "00" };
  const h = Math.min(23, Math.max(0, parseInt(match[1], 10)));
  const m = Math.min(59, Math.max(0, parseInt(match[2], 10)));
  return {
    hour: h.toString().padStart(2, "0"),
    minute: m.toString().padStart(2, "0"),
  };
}

export interface TimeSelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const TimeSelect = ({
  id,
  label,
  value,
  onChange,
  className = "",
}: TimeSelectProps) => {
  const { hour, minute } = parseTime(value);

  const handleHourChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(`${e.target.value}:${minute}`);
  };

  const handleMinuteChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(`${hour}:${e.target.value}`);
  };

  return (
    <div className={`space-y-1 ${className}`.trim()}>
      <label className="text-label" htmlFor={id}>
        {label}
      </label>
      <div className="flex gap-2">
        <select
          id={id}
          aria-label="Hora"
          className="input-compact flex-1 min-w-0"
          value={hour}
          onChange={handleHourChange}
        >
          {HOURS.map((h) => (
            <option key={h} value={h}>
              {h}:00
            </option>
          ))}
        </select>
        <select
          aria-label="Minutos"
          className="input-compact flex-1 min-w-0"
          value={minute}
          onChange={handleMinuteChange}
        >
          {MINUTES.map((m) => (
            <option key={m} value={m}>
              {m} min
            </option>
          ))}
        </select>
      </div>
      <p className="text-size-2xs text-global-tertiary">
        Útil para registrar gastos anteriores. Dejar vacío para usar la fecha
        actual.
      </p>
    </div>
  );
};
